import React, { useEffect, useRef, useState } from 'react';

// «− N +» одной рамкой (07.10, как в составе букета): кнопки без своих рамок, поле
// между ними отделено тонкими линиями. Один компонент для всех счётчиков админки.
// Внешняя рамка и срез — одного цвета (#D8DDDA), без overflow: hidden (съедает контур среза).
const BORDER = '#EBEDEC';
const LINE = '#D8DDDA';
const btnStyle = {
  width: 30, height: 32, border: 'none', background: 'transparent',
  fontSize: 18, lineHeight: 1, color: '#1C3D2E', fontWeight: 600, padding: 0, fontFamily: 'inherit',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
};
const inputStyle = {
  width: 40, padding: 6, textAlign: 'center', border: 'none',
  borderLeft: `1px solid ${BORDER}`, borderRight: `1px solid ${BORDER}`,
  fontSize: 14, fontWeight: 600, color: '#1C3D2E', background: 'transparent', outline: 'none',
};

/**
 * Счётчик количества «− [n] +» для штучного счёта: позиции заказа, компоненты
 * букета, стебли сборного букета, упаковка.
 *
 * Поле — текстовое, а не type="number": у числового React не перезаписывает DOM,
 * когда «02» == 2, и ввод превращался в «020»; здесь в стейте живёт строка,
 * ведущие нули срезаются на вводе, пустое поле возвращается к прежнему
 * значению при уходе фокуса. Наружу уходят только целые числа в [min, max].
 */
export default function QtyStepper({ value, onChange, min = 1, max, step = 1, disabled = false, style }) {
  const current = Number.isFinite(parseInt(value, 10)) ? parseInt(value, 10) : min;
  const [text, setText] = useState(String(current));
  const focused = useRef(false);

  useEffect(() => {
    if (!focused.current) setText(String(current));
  }, [current]);

  const clamp = (n) => {
    let v = n;
    if (min != null && v < min) v = min;
    if (max != null && v > max) v = max;
    return v;
  };
  const commit = (n) => {
    const v = clamp(n);
    setText(String(v));
    if (v !== current) onChange(v);
  };

  const minusDisabled = disabled || (min != null && current - step < min);
  const plusDisabled = disabled || (max != null && current + step > max);

  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', flexShrink: 0,
      border: `1px solid ${LINE}`, '--ch': '5px', '--stroke': LINE,
      background: disabled ? '#F4F4EF' : '#fff', ...style,
    }}>
      <button
        type="button"
        onClick={() => commit(current - step)}
        disabled={minusDisabled}
        style={{ ...btnStyle, opacity: minusDisabled ? 0.45 : 1, cursor: minusDisabled ? 'not-allowed' : 'pointer' }}
      >−</button>
      <input
        type="text"
        inputMode="numeric"
        className="no-spinner"
        value={text}
        disabled={disabled}
        onFocus={(e) => { focused.current = true; e.target.select(); }}
        onChange={(e) => {
          const raw = e.target.value.replace(/^0+(?=\d)/, '');
          if (!/^\d*$/.test(raw)) return;
          setText(raw);
          const n = parseInt(raw, 10);
          if (Number.isFinite(n)) {
            const v = clamp(n);
            if (v !== current) onChange(v);
          }
        }}
        onBlur={() => {
          focused.current = false;
          const n = parseInt(text, 10);
          commit(Number.isFinite(n) ? n : current);
        }}
        style={inputStyle}
      />
      <button
        type="button"
        onClick={() => commit(current + step)}
        disabled={plusDisabled}
        style={{ ...btnStyle, opacity: plusDisabled ? 0.45 : 1, cursor: plusDisabled ? 'not-allowed' : 'pointer' }}
      >+</button>
    </div>
  );
}
